import { gql } from '@apollo/client';

import { HorizontalStack, HorizontalStackProps } from '../utils/linearLayouts';
import { DisciplineChip } from './DisciplineChip';

interface IDisciplineTagProps {
    discipline: IDisciplineTag;
}

export interface IDisciplineTag {
    id: string;
    name: string | null;
    displayName: string;
    code: string;
}

export const DisciplineTagFragment = gql`
    fragment DisciplineTagFragment on Discipline {
        id
        name
        displayName
        code
    }
`;

export const DisciplineTag = ({ discipline }: IDisciplineTagProps) => {
    return <DisciplineChip discipline={discipline} sx={{ borderRadius: 0.3 }} />;
};

export const DisciplineTags = ({
    disciplines,
    ...rest
}: {
    disciplines: IDisciplineTagProps['discipline'][];
} & Omit<HorizontalStackProps, 'children'>) => {
    return (
        <HorizontalStack spacing={1} {...rest}>
            {disciplines.map((discipline) => (
                <DisciplineTag key={discipline.id} discipline={discipline} />
            ))}
        </HorizontalStack>
    );
};
